"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var image_1 = __importDefault(require("next/image"));
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var Languages_1 = __importDefault(require("../Languages"));
var MenuTabs_1 = __importDefault(require("../MenuTabs"));
var ProfileMenuList_1 = __importDefault(require("../ProfileMenuList"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AuthProfileMenu = function (_a) {
    var _b, _c;
    var promoLink = _a.promoLink, languages = _a.languages;
    var pathname = (0, navigation_1.usePathname)();
    var t = (0, next_intl_1.useTranslations)('translation');
    var tAll = (0, next_intl_1.useTranslations)();
    var _d = (0, react_1.useState)(pathname.includes('/account') ? 'account' : 'main'), menuTab = _d[0], setMenuTab = _d[1];
    var openManager = (0, common_hooks_1.usePremiumSupport)().openManager;
    var config = (0, swr_hooks_1.useConfig)();
    var _e = (0, swr_hooks_1.usePlayerStatus)(), isLoading = _e.isLoading, currentLevelInfo = _e.currentLevelInfo;
    var playerName = (0, swr_hooks_1.usePlayerName)();
    var signOut = (0, swr_hooks_1.useSignOut)().signOut;
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var openDeposit = (0, apps_shared_1.useOpenDeposit)();
    var signOutHandler = (0, react_1.useCallback)(function () {
        signOut();
        closeWindow();
    }, [closeWindow, signOut]);
    var generateUrlWithLang = (0, apps_shared_1.useGenerateUrlWithLang)();
    var data = (0, swr_hooks_1.useBalance)().data;
    var openReferralWidget = (0, common_hooks_1.useOpenReferralWidget)();
    var secondaryMenuList = (0, react_1.useMemo)(function () {
        var _a;
        var defaultList = [
            {
                label: t('promotions'),
                icon: '/img/profileMenu/bonuses.svg',
                iconActive: '/img/profileMenu/bonusesActive.svg',
                href: generateUrlWithLang('/promotions'),
            },
            {
                label: t('tournaments'),
                slug: 'tournaments',
                icon: '/img/profileMenu/tournaments.svg',
                iconActive: '/img/profileMenu/tournamentsActive.svg',
                href: generateUrlWithLang('/tournaments'),
            },
            {
                label: t('vipclub'),
                icon: '/img/profileMenu/vip.svg',
                iconActive: '/img/profileMenu/vipActive.svg',
                href: generateUrlWithLang('/vip'),
            },
        ];
        var filteredList = (config === null || config === void 0 ? void 0 : config.hideTournaments)
            ? defaultList.filter(function (item) { return item.slug !== 'tournaments'; })
            : defaultList;
        if (!(config === null || config === void 0 ? void 0 : config.disablePaymentsLink))
            defaultList.push({
                label: t('payments'),
                icon: '/img/profileMenu/bank.svg',
                iconActive: '/img/profileMenu/bankActive.svg',
                href: generateUrlWithLang('/payments'),
            });
        if (config === null || config === void 0 ? void 0 : config.enabledInviteFriends) {
            filteredList.unshift({
                label: t('inviteFriends'),
                icon: '/img/profileSidebar/invite.svg',
                iconActive: '/img/profileSidebar/invite-hover.svg',
                href: '#',
                //@ts-ignore
                onClick: openReferralWidget,
            });
        }
        if (config === null || config === void 0 ? void 0 : config.additionalPages) {
            var additionalPages = (_a = config === null || config === void 0 ? void 0 : config.additionalPages) === null || _a === void 0 ? void 0 : _a.map(function (link) { return ({
                label: link.name,
                icon: link === null || link === void 0 ? void 0 : link.icon,
                href: link.link,
            }); });
            return __spreadArray(__spreadArray([], additionalPages, true), filteredList, true);
        }
        return promoLink
            ? __spreadArray([
                {
                    label: t('promo'),
                    icon: '/img/promo/bonusIcon.svg',
                    href: generateUrlWithLang(promoLink),
                }
            ], filteredList, true) : filteredList;
    }, [promoLink, t, generateUrlWithLang, config]);
    var accountMenuList = (0, react_1.useMemo)(function () {
        var _a;
        return [
            {
                label: t('wallet'),
                icon: '/img/profileSidebar/wallet.svg',
                iconActive: '/img/profileSidebar/wallet-hover.svg',
                href: generateUrlWithLang('/account/wallet/balance'),
                parentHref: generateUrlWithLang('/account/wallet'),
            },
            {
                label: t('history'),
                icon: '/img/profileSidebar/bets.svg',
                iconActive: '/img/profileSidebar/bets-hover.svg',
                href: generateUrlWithLang('/account/history/transactions'),
                parentHref: generateUrlWithLang('/account/history'),
            },
            {
                label: t('bonusesAndFreespins'),
                icon: '/img/profileSidebar/bonuses.svg',
                iconActive: '/img/profileSidebar/bonuses-hover.svg',
                href: generateUrlWithLang("/account/bonuses/".concat((_a = config.headerDropdownBonusesPath) !== null && _a !== void 0 ? _a : 'cash')),
                parentHref: generateUrlWithLang('/account/bonuses'),
            },
            {
                collapse: true,
                slug: 'bonusActivities',
                label: tAll('bonusActivities.bonusActivities'),
                icon: '/img/profileSidebar/bonusActivities.svg',
                iconActive: '/img/profileSidebar/bonusActivities-hover.svg',
                items: [
                    {
                        href: generateUrlWithLang('/account/bonus-activities/lottery'),
                        label: tAll('lottery.lottery'),
                    },
                    {
                        href: generateUrlWithLang('/account/bonus-activities/wheel'),
                        label: tAll('wheel.wheel'),
                    },
                ],
                parentHref: generateUrlWithLang('/account/bonus-activities'),
            },
            {
                label: t('profile'),
                icon: '/img/profileSidebar/profile.svg',
                iconActive: '/img/profileSidebar/profile-hover.svg',
                href: generateUrlWithLang('/account/profile/general'),
                parentHref: generateUrlWithLang('/account/profile'),
            },
        ].filter(function (item) {
            if (item.slug === 'bonusActivities' && (config === null || config === void 0 ? void 0 : config.hideBonusActivities)) {
                return false;
            }
            return true;
        });
    }, [t, generateUrlWithLang, config, tAll]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        !isLoading && (react_1.default.createElement("div", { className: styles_module_scss_1.default.header },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.closeIcon },
                react_1.default.createElement(ui_components_1.CloseIcon, { onClickHandler: closeWindow })),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.inner },
                react_1.default.createElement(image_1.default, { width: 48, height: 48, className: styles_module_scss_1.default.img, src: ((_b = currentLevelInfo === null || currentLevelInfo === void 0 ? void 0 : currentLevelInfo.images) === null || _b === void 0 ? void 0 : _b.big) || apps_shared_1.userLevelsImages.level0Default, alt: "user" }),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.headerBlock },
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.headerContent }, playerName),
                    react_1.default.createElement("div", { className: styles_module_scss_1.default.headerBalance }, "".concat((_c = Number(data === null || data === void 0 ? void 0 : data.totalAmount)) === null || _c === void 0 ? void 0 : _c.toFixed(2), " "),
                        react_1.default.createElement("span", null, (0, apps_shared_1.getCurrencySymbol)(data === null || data === void 0 ? void 0 : data.currency))))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.depositBtnWrapper },
                react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", width: "100%", maxWidth: "100%", text: "upper", onClick: openDeposit }, t('deposit'))))),
        react_1.default.createElement(MenuTabs_1.default, { tabs: [
                { label: t('main'), value: 'main' },
                { label: t('account'), value: 'account' },
            ], defaultValue: menuTab, onChange: function (tab) { return setMenuTab(tab); } }),
        react_1.default.createElement("nav", { className: styles_module_scss_1.default.menu },
            menuTab === 'main' ? (react_1.default.createElement(react_1.default.Fragment, null,
                ((config === null || config === void 0 ? void 0 : config.withCasinoInBurger) || (config === null || config === void 0 ? void 0 : config.withSportInBurger)) && (react_1.default.createElement(ProfileMenuList_1.default, { haveBalance: false, items: __spreadArray(__spreadArray([], ((config === null || config === void 0 ? void 0 : config.withCasinoInBurger)
                        ? [
                            {
                                label: 'Casino',
                                icon: '/img/profileMenu/casino.svg',
                                iconActive: '/img/profileMenu/casinoActive.svg',
                                href: generateUrlWithLang('/'),
                            },
                        ]
                        : []), true), ((config === null || config === void 0 ? void 0 : config.withSportInBurger)
                        ? [
                            {
                                label: t('sport'),
                                icon: '/img/profileMenu/sport.svg',
                                iconActive: '/img/profileMenu/sportActive.svg',
                                href: generateUrlWithLang('/betting/sports/live'),
                            },
                        ]
                        : []), true) })),
                react_1.default.createElement(ProfileMenuList_1.default, { haveBalance: false, items: [
                        {
                            label: "".concat(t('top'), " ").concat(t('games')),
                            icon: '/img/profileMenu/topGames.svg',
                            iconActive: '/img/profileMenu/topGamesActive.svg',
                            href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.profileMenuTopGamesPageSlug)
                                ? config === null || config === void 0 ? void 0 : config.profileMenuTopGamesPageSlug
                                : '/games/top'),
                        },
                        {
                            label: "".concat(t('new'), " ").concat(t('games')),
                            icon: '/img/profileMenu/newGames.svg',
                            iconActive: '/img/profileMenu/newGamesActive.svg',
                            href: generateUrlWithLang('/games/new'),
                        },
                        {
                            label: "".concat(t('favorites')),
                            icon: '/img/profileMenu/favorites.svg',
                            iconActive: '/img/profileMenu/favoritesActive.svg',
                            href: generateUrlWithLang('/games/favorites'),
                        },
                    ] }),
                react_1.default.createElement(ProfileMenuList_1.default, { items: secondaryMenuList }))) : (react_1.default.createElement(ProfileMenuList_1.default, { items: accountMenuList })),
            !(config === null || config === void 0 ? void 0 : config.liveChatShouldDisabled) && (react_1.default.createElement("div", { className: styles_module_scss_1.default.supportWrapper },
                react_1.default.createElement("div", { onClick: openManager, className: styles_module_scss_1.default.support },
                    react_1.default.createElement("img", { src: "/img/profileMenu/support.svg", alt: "Account" }),
                    react_1.default.createElement("span", null, t('support'))))),
            react_1.default.createElement(ProfileMenuList_1.default, { secondary: true, items: [
                    {
                        label: t('termsOfUse'),
                        icon: '/img/profileMenu/terms.svg',
                        iconActive: '/img/profileMenu/terms.svg',
                        href: generateUrlWithLang((config === null || config === void 0 ? void 0 : config.generalTermsAndConditionsLink) || '/terms-of-use'),
                        target: '_blank',
                        langs: react_1.default.createElement(Languages_1.default, { languages: languages }),
                    },
                ] }),
            react_1.default.createElement(ProfileMenuList_1.default, { secondary: true, items: [
                    {
                        label: t('signOut'),
                        icon: '/img/profileMenu/signout.svg',
                        onClick: signOutHandler,
                    },
                ] }))));
};
exports.default = AuthProfileMenu;
